import { enableMapSet } from 'immer';

// Enable Map/Set support once at app startup
enableMapSet();

